import React from 'react';
import { useState } from 'react';
import { useCrossMarketStatus } from '../hooks/useCrossMarketStatus';
import { useStrategyExecution } from '../hooks/useStrategyExecution';
import KrStrategyExecutionPanel from '../components/strategy/KrStrategyExecutionPanel';
import UsStrategyExecutionPanel from '../components/strategy/UsStrategyExecutionPanel';
import './StrategyExecution.css';
import './SystemOverview.css';

const StrategyExecution: React.FC = () => {
  const [market, setMarket] = useState<'US' | 'KR'>('US');
  const marketStatus = useCrossMarketStatus();
  const usLive = isUsLive(marketStatus.data);
  const state = useStrategyExecution({
    enableAiWatchlist: marketStatus.data ? !usLive : false,
  });

  if (state.loading && state.aiStocks.length === 0) {
    return (
      <div className="strategy-execution">
        <div className="loading">로딩 중...</div>
      </div>
    );
  }

  if (state.error && state.aiStocks.length === 0) {
    return (
      <div className="strategy-execution">
        <div className="error">오류: {state.error}</div>
      </div>
    );
  }

  return (
    <div className="strategy-execution">
      <h2>전략 자동 실행 모니터링</h2>
      <p className="strategy-market-note">
        {usLive
          ? 'US live_pilot은 Toss 검증 watchlist 기준으로 실행합니다. KR은 별도 switch 승인 전까지 잠금 상태입니다.'
          : '같은 운영 화면에서 시장을 전환합니다. US paper 검증은 Alpaca, Toss LIVE 후보 검증은 Toss 기준입니다.'}
      </p>
      <div className="strategy-market-tabs" aria-label="전략 실행 시장 선택">
        <button className={market === 'US' ? 'active' : ''} onClick={() => setMarket('US')}>
          {usLive ? 'US / Toss live pilot' : 'US / Alpaca paper'}
        </button>
        <button className={market === 'KR' ? 'active' : ''} onClick={() => setMarket('KR')}>
          KR / Toss readiness
        </button>
      </div>
      {market === 'US'
        ? <UsStrategyExecutionPanel state={state} status={marketStatus.data} />
        : <KrStrategyExecutionPanel />}
    </div>
  );
};

function isUsLive(status: ReturnType<typeof useCrossMarketStatus>['data']) {
  const safety = status?.safety;
  return Boolean(
    safety?.trading_mode === 'live'
    && safety.live_trading_enabled
    && safety.toss_live_market === 'US'
    && safety.toss_us_live_enabled
  );
}

export default StrategyExecution;
